import styled from "styled-components";
import { ImgBlankProfile } from "../../../assets/images";
import CardLayout from "../../../layouts/CardLayout";
import {
  EditIcon,
  EmailIcon,
  FemaleIcon,
  IDIcon,
  MaleIcon,
  PhoneIcon
} from "../../../utils/icon.utils";
import Button from "../../../ui/Button";

export default function CustomerGeneralInfo({ data, onEdit }) {
  return (
    <CardLayout>
      <div className="d-flex gap-3">
        <Avatar className="rounded-circle" style={{ backgroundImage: `url(${ImgBlankProfile})` }} />
        <div className="pt-2">
          <h4 className="mb-0">{data?.name ?? "-"}</h4>
          <p>{data?.role ?? ""}</p>
        </div>
      </div>

      <ul className="list-unstyled mb-0">
        <li>
          <IDIcon /> {data?.customer_id || "-"}
        </li>
        <li>
          {data?.gender_name === "Male" ? (
            <MaleIcon />
          ) : data?.gender_name === "Female" ? (
            <FemaleIcon />
          ) : (
            ""
          )}{" "}
          {data?.gender_name || "-"}
        </li>
        <li>
          <PhoneIcon /> {data?.mobile || <NotAvailable>Mobile number not available</NotAvailable>}
        </li>
        <li>
          <EmailIcon /> {data?.email || <NotAvailable>Email address not available</NotAvailable>}
        </li>
      </ul>

      <div className="text-end">
        <Button onClick={() => onEdit(data)} name="Edit" icon={EditIcon} />
      </div>
    </CardLayout>
  );
}

const Avatar = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  height: 4rem;
  width: 4rem;
`;

const NotAvailable = styled.span`
  font-style: italic;
  font-size: 12px;
  font-weight: 500;
`;
